// extracted by mini-css-extract-plugin
export default {"bar":"styles_bar__ijZ2x","progress":"styles_progress__FBjTG"};